import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import RegisterNewPatient from "./RegisterNewPatient";
import PatientDocuments from "./PatientDocuments/PatientDocuments";
import PatientHistory from "./PatientHistory/PatientHistory";
import SearchViewPatients from "./SearchViewPatients";
import InsuranceandTPAManagement from "./InsuranceandTPAManagement";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
import { includeCardForRoles, ROLES } from "../componenet/heading";



 

const PatientDashBoard = () => {

  const tokenData = localStorage.getItem("tokenData");
  const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  const userName = decryptedData.userfullname || "";
const userRole = decryptedData.userrole || "";
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


const cardRoles = {
  "New Patient Registration": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Patient History": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Search / View Patients": [ROLES.RECEPTIONIST],
  "Insurance and TPI Management": [ROLES.STAFF],
  "Patient Documents Management": [ROLES.ACCOUNTSECTION],
  
};




  const cards = [
    ...includeCardForRoles(cardRoles["New Patient Registration"], userRole,{
      title: "New Patient Registration",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <RegisterNewPatient />,category: "👨‍⚕️ Patient Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Patient History"], userRole,{
      title: "Patient History",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <PatientHistory />,category: "👨‍⚕️ Patient Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Search / View Patients"], userRole,{
      title: "Search / View Patients",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <SearchViewPatients />,category: "👨‍⚕️ Patient Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Insurance and TPI Management"], userRole,{
      title: "Insurance and TPI Management",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <InsuranceandTPAManagement />,category: "👨‍⚕️ Patient Data Managament",
    }),

    ...includeCardForRoles(cardRoles["Patient Documents Management"], userRole,{
      title: "Patient Documents Management",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <PatientDocuments />,category: "👨‍⚕️ Patient Data Managament",
    }),
  ];

  const handleCardClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


 
   return (
    <DashboardCards
      cards={cards}
      menulabel={1}
      welcomeMessage={
        <Typography variant="h5" align="center" gutterBottom>
         👨‍⚕️ Patient Data Managament
        </Typography>
      }
    />
  );
};

export default PatientDashBoard;
